import { Button } from "primereact/button";

export let primeUserColumns = [
    {
        attr: "fullName",
        label: "Полное имя",
        type: 1,
        filter: true,
        body: (row) => {

            return <>{row.first_name + " " + row.last_name}</>
        }
    }, {
        attr: "order_count",
        label: "Все заказы",
        type: 1,
        filter: true,
    }, {
        attr: "order_count",
        label: "orders",
        type: 1,
        filter: true,
    }, {
        attr: "created_date",
        label: "Дата создания",
        type: 1,
        filter: true,
        body: (row, field) => {
            let text = ''

            if (row[field.field]) {
                text = new Date(row[field.field]).toLocaleDateString()
            }

            return <>{text}</>
        }
    }
]